import React from 'react';
import { WidgetWrapper } from '@/src/components/projects/ProjectDashboard/WidgetWrapper.jsx';
import { WidgetInner } from '@/src/components/projects/ProjectDashboard/WidgetInner.jsx';
import { getOrgTermsContent } from '@/src/content/utils.js';
import VerticalSeparator from '@/src/components/VerticalSeparator.jsx';
import { ProjectIconLarge } from '@/src/components/icons/ProjectIconLarge.jsx';
import OwnersList from '@/src/components/OwnersList.jsx';
import Time from 'react-time';
import DatesProgressBar from '@/src/components/projects/DatesProgressBar.jsx';
import { WidgetCard } from '@/src/components/projects/ProjectDashboard/WidgetCard.jsx';
import SentimentDot from '@/src/components/SentimentDot.jsx';
import classNames from 'classnames';
import kebabCase from 'lodash/kebabCase';
import { Col, Row } from 'react-bootstrap';

export const ProjectOverviewWidget = ({ data }) => {
  const {
    parentPortfolioName,
    portfolioName,
    name,
    status,
    owners,
    endDate,
    startDate,
    impact,
    scope,
    hasParentPortfolios,
    impactsTotalCount,
    initiativesTotalCount,
  } = data;

  return (
    <WidgetWrapper className="project-overview-widget">
      <Row>
        <Col xs={12}>
          <div className="flex flex-justify flex-align-start m-b-24">
            <div className="flex">
              <div className="project-icon m-r-12">
                <ProjectIconLarge />
              </div>
              <div className="flex flex-col flex-align-start">
                <h2 className="m-b-12">{name}</h2>
                <div className="flex">
                  {hasParentPortfolios ? (
                    <React.Fragment>
                      <div className="flex header-item">
                        <strong className="text-muted m-r-12">
                          {getOrgTermsContent('parentPortfolio')}:
                        </strong>
                        <strong>{parentPortfolioName || '—'}</strong>
                      </div>
                      <VerticalSeparator />
                    </React.Fragment>
                  ) : null}
                  <div className="flex header-item">
                    <strong className="text-muted">
                      {getOrgTermsContent('portfolio')}:
                    </strong>
                    <strong className="m-l-12">{portfolioName || '—'}</strong>
                  </div>
                </div>
              </div>
            </div>
            <strong className="header-item bordered bordered-lg component-bg-white text-primary">
              <span className="">{status}</span>
            </strong>
          </div>
        </Col>
        <Col xs={6}>
          <WidgetInner>
            <div className="text-muted m-b-10">Owner(s):</div>
            <OwnersList owners={owners} nameKey="fullName" row={true} />
            <hr className="m-t-12 m-b-12" />
            <div className="text-muted m-b-10">Dates:</div>
            {endDate && startDate ? (
              <>
                <div className="m-b-4">
                  <Time value={startDate} format="M/D/YY" />
                  &nbsp; - &nbsp;
                  <Time value={endDate} format="M/D/YY" />
                </div>
                <DatesProgressBar startDate={startDate} endDate={endDate} />
              </>
            ) : (
              '—'
            )}
          </WidgetInner>
        </Col>
        <Col xs={6}>
          <WidgetInner transparent noBorder className="px-0 py-0">
            <div className="widget-grid">
              <WidgetCard sentiment={impact} reverse className="p-x-24 p-y-26">
                <div className="flex flex-justify">
                  <h4>Impact:</h4>

                  {impact ? (
                    <div
                      className={classNames('flex sentiment-wrapper', {
                        [`sentiment-wrapper-${kebabCase(`-${impact}-reverse`)}`]:
                          impact,
                      })}
                    >
                      <SentimentDot sentiment={impact} reverse />
                      <h3 className="text-capitalize">{impact}</h3>
                    </div>
                  ) : (
                    '—'
                  )}
                </div>
              </WidgetCard>
              <WidgetCard sentiment="default" className="p-x-24 p-y-26">
                <div className="flex flex-justify">
                  <h4>{getOrgTermsContent('initiatives')}:</h4>
                  <h3>{initiativesTotalCount}</h3>
                </div>
              </WidgetCard>
              <WidgetCard sentiment={scope} reverse className="p-x-24 p-y-26">
                <div className="flex flex-justify">
                  <h4>Scope:</h4>
                  {scope ? (
                    <div
                      className={classNames('flex sentiment-wrapper', {
                        [`sentiment-wrapper-${kebabCase(`-${scope}-reverse`)}`]:
                          scope,
                      })}
                    >
                      <SentimentDot sentiment={scope} reverse />
                      <h3 className="text-capitalize">{scope}</h3>
                    </div>
                  ) : (
                    '—'
                  )}
                </div>
              </WidgetCard>
              <WidgetCard sentiment="default" className="p-x-24 p-y-26">
                <div className="flex flex-justify">
                  <h4>Change Impacts:</h4>
                  <h3>{impactsTotalCount}</h3>
                </div>
              </WidgetCard>
            </div>
          </WidgetInner>
        </Col>
      </Row>
    </WidgetWrapper>
  );
};
